import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupByDate',
})
export class GroupByDate implements PipeTransform {
    transform(value, args: string[]): any {
        const groups = {};
        if (value != null)
            if (value.length > 0) {
                value.forEach(function(o) {
                    const group = o.MatchGroupDate;
                    groups[group] = groups[group] ? groups[group] : { MatchGroupDate: group, events: [] };
                    groups[group].events.push(o);
                });
            }
        return Object.keys(groups).map(function(key) {
            return groups[key];
        });
    }
}
